<template>
	<div class="unrestricted-banner max-w-screen">
		<div class="unrestricted-banner__placeholder p-4"></div>
		<CCallout type="warning" :use-icon="false" class="unrestricted-banner__container">
			<div class="flex items-center">
				<span class="text-nowrap">You are accessing this organization as an unrestricted support user. Any changes you make will persist.</span>
			</div>
		</CCallout>
	</div>
</template>
<script lang="ts">
	import { defineComponent } from 'vue';
	import CCallout from 'src/components/content/Callout.vue';

	export default defineComponent({
		name: 'CViewAsUserBanner',
		components: {
			CCallout
		}
	});
</script>
<style lang="scss">
	.unrestricted-banner {

		&__container {
			position: fixed;
			top: 0;
			z-index: $z-view-as-banner;
			width: 100%;
			max-width: 100vw;
			border-top: 0;
			border-right: 0;
			border-left: 0;
		}

		// Placeholder for the banner on the settings pages
		&__placeholder {
			max-width: 100vw;
			height: 16px;
			border-bottom: 1px solid transparent;
			box-sizing: content-box;
			visibility: hidden;
		}

		@media print {
			display: none !important;
		}

		:root:root & {
			margin-bottom: 0;
		}
	}
</style>